module.exports = __webpack_public_path__ + "static/img/wireframing.7d76d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wireframing.png
// module id = OR+T
// module chunks = 1